import { connect } from "react-redux";
import React, { useEffect, useState } from 'react';
import { withRouter, useHistory, useLocation } from 'react-router-dom';
import * as logger from '../../../../logger';
import {
    DialogTitle,
    Paper,
    Grid,
    Button,
    ExpansionPanelDetails,
    Dialog,
    DialogContent,
    DialogActions,
    IconButton,
    InputAdornment,
    Card,
    CardContent,
    Typography,
} from '@material-ui/core';
import { FuelBookCss as useStyles } from '../VehicleCss';
import RightSideBar from '../../../components/RightSideBar/RightSideBar';
import { singleTruck, fetchFuelBook, PandL, Expenses, FetchExpenseDetails } from '../../../../store/actions/vehicleActionCreator';
import DateFilter from "../../../components/FilterComponent/DateFilter";
import CustomDateFilterDialog from '../../../components/FilterComponent/CustomDateFilter';
import { numberFormat, getDateInStringDocumentDDMMMYYYY, getVehicleNumberValuesDWeb, numberFormatComma, getTripDateFilterValues, getDateStringDDMMM } from '../../../../utils/utils';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import DeleteExpenseDialog from '../../../components/VehicleDialogs/DeleteExpenseDialog';
import AddFuelExpenseDialog from '../../../components/VehicleDialogs/AddFuelExpenseDialog';
import { FuelBookIcon } from '../../../../components/icons';
import { trackDwebEvent } from "../../../analytics";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

const FuelBook = ({ open, onClose, vehicle, dispatchGetSingleTruck, dispatchFetchSingleExpense, dispatchGetTripExpenses, dispatchGetFuelBook, dispatchGetPandL }) => {

    let submit, formValues;

    const [onOpen, setOnOpen] = useState(null);
    const [dateFilterValue, setDateFilterValue] = useState("ALL_MONTHS");
    const [fuelBookDetails, setFuelBookDetails] = useState({});
    const [vehicleNumberType, setVehicleNumberType] = useState({ vehicleNumberPrefix: "", vehicleNumberSuffix: "" })
    const [changeFlag, setChangeFlag] = useState(false);
    const [deleteExpenseDialogOpen, setDeleteExpenseDialogOpen] = useState(false);
    const [expenseIdValue, setExpenseIdValue] = useState("");
    const [addFuelExpenseOpen, setAddFuelExpenseOpen] = useState(false);
    const [singleExpenseDetails, setSingleExpenseDetails] = useState({});
    const [editExpenseDialog, setEditExpenseDialog] = useState(false);
    const [customFilter, setCustomFilter] = useState(false);
    const [customFilterValue, setCustomFilterValue] = useState({});

    const classes = useStyles();

    let location = useLocation();
    let path = location && location.pathname ? location.pathname.split("/") : [];
    let vehicleId = path && path[path.length - 1] ? path[path.length - 1] : "";

    var dateFilterValueUtil = getTripDateFilterValues();

    useEffect(() => {
        if (fuelBookDetails && fuelBookDetails.vehicleId) {
            trackDwebEvent("Dweb SVP Fuel Book ", {
                vehicle_id: vehicleId,
                vehicle_number: fuelBookDetails && fuelBookDetails.vehicleNumber ? fuelBookDetails.vehicleNumber : "",
                total_fuel_expense: fuelBookDetails && fuelBookDetails.totalCost ? fuelBookDetails.totalCost : ""
            });
        }
    }, [fuelBookDetails]);

    useEffect(() => {

        var startDateRange = dateFilterValueUtil[dateFilterValue].startDateRange;

        let fuelData = {
            vehicleId: Number(vehicleId),
            dateRange: {
                startTimeEpoch: startDateRange.startTimeEpoch,
                endTimeEpoch: startDateRange.endTimeEpoch
            }
        };

        dispatchGetFuelBook(fuelData,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log("Fuel Book Dweb", "Get fuel book successfull");
                    setOnOpen(true);
                }
            },
            () => {
                logger.log("Fuel Book Dweb", "Get fuel book failed")
            }
        );

    }, [open]);

    useEffect(() => {
        if (vehicle.truckBooks) {
            setFuelBookDetails(vehicle.truckBooks);
            const vehicleNumberArray = getVehicleNumberValuesDWeb(vehicle.truckBooks.vehicleNumber);
            if (vehicleNumberArray && vehicleNumberArray.length > 0) {
                const vehicleNumberSuffixValue = vehicleNumberArray.pop();
                const vehicleNumberPrefixValue = vehicleNumberArray.join("");

                setVehicleNumberType({
                    vehicleNumberPrefix: vehicleNumberPrefixValue,
                    vehicleNumberSuffix: vehicleNumberSuffixValue,
                })
            }
        }

        if (vehicle.singleExpenseDetails) {
            setSingleExpenseDetails(vehicle.singleExpenseDetails)
        }
    }, [vehicle.truckBooks, vehicle.singleExpenseDetails]);

    useEffect(() => {

        if (changeFlag) {

            var startDateRange = dateFilterValueUtil[dateFilterValue].startDateRange;


            let fuelData = {
                vehicleId: Number(vehicleId),
                dateRange: {
                    startTimeEpoch: startDateRange.startTimeEpoch,
                    endTimeEpoch: startDateRange.endTimeEpoch
                }
            };

            if (customFilterValue && customFilterValue.startTimeEpoch) {
                fuelData.dateRange = customFilterValue;
            }

            dispatchGetFuelBook(fuelData,
                (data) => {
                    if (data && data.status && data.status.code == 200) {
                        logger.log("Fuel Book Dweb", "Get fuel book successfull");
                    }
                },
                () => {
                    logger.log("Fuel Book Dweb", "Get fuel book failed")
                }
            );

        }

    }, [dateFilterValue, customFilterValue]);

    const recall = () => {

        var startDateRange = dateFilterValueUtil["ALL_MONTHS"].startDateRange;

        var PandLdata = {
            vehicleId: Number(vehicleId),
            startDateRange: {
                startTimeEpoch: startDateRange.startTimeEpoch,
                endTimeEpoch: startDateRange.endTimeEpoch
            }
        };

        var expenseData = {
            vehicleId: Number(vehicleId),
            startDateRange: {
                startTimeEpoch: startDateRange.startTimeEpoch,
                endTimeEpoch: startDateRange.endTimeEpoch
            },
            expenseParentType: []
        };

        let fuelData = {
            vehicleId: Number(vehicleId),
            dateRange: {
                startTimeEpoch: startDateRange.startTimeEpoch,
                endTimeEpoch: startDateRange.endTimeEpoch
            }
        };

        let defaultDateFilterValue = "ALL_MONTHS";
        let defaultTripBookFilterValue = "All Trips & Expenses";


        dispatchGetFuelBook(fuelData,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log("Fuel Book Dweb", "Get fuel book successfull");

                    dispatchGetPandL(PandLdata, defaultDateFilterValue,
                        (data) => {
                            if (data && data.status && data.status.code == 200) {
                                logger.log("Fuel Book Dweb", "Get P and L report Successfull");
                                dispatchGetTripExpenses(expenseData, defaultTripBookFilterValue,
                                    (data) => {
                                        if (data && data.status && data.status.code == 200) {
                                            logger.log("Fuel Book Dweb", "Get Trip Expenses report Successfull");
                                        }
                                    },
                                    () => {
                                        logger.log("Fuel Book Dweb", "Get Trip Expenses report Failed");
                                    },
                                )
                            }
                        },
                        () => {
                            logger.log("Fuel Book Dweb", "Get P and L report Failed");
                        },
                    )
                }
            },
            () => {
                logger.log("Fuel Book Dweb", "Get fuel book failed")
            }
        );
    }

    const handleAddFuelExpense = () => {
        trackDwebEvent("Dweb SVP Fuel Book Expense Initiated", {
            vehicle_id: vehicleId,
            vehicle_number: fuelBookDetails && fuelBookDetails.vehicleNumber ? fuelBookDetails.vehicleNumber : "",
            total_fuel_expense: fuelBookDetails && fuelBookDetails.totalCost ? fuelBookDetails.totalCost : ""
        });
        setAddFuelExpenseOpen(true);
        setSingleExpenseDetails({});
    }

    const onConfirm = () => {
        setOnOpen(false);
        onClose();
    }

    const handleDateValue = (value) => {
        if (value == "CUSTOM") {
            setCustomFilter(true);
        }
        else {
            setDateFilterValue(value);
            setCustomFilter(false);
            setCustomFilterValue({});
        }
        setChangeFlag(true);
    }

    const handleDeleteExpense = (expenseId) => {
        setExpenseIdValue(expenseId);
        setDeleteExpenseDialogOpen(true);
    }

    const handleDeleteClose = () => {
        setDeleteExpenseDialogOpen(false);
    }

    const handleDeleteExpenseConfirm = () => {
        setDeleteExpenseDialogOpen(false);
        recall();
    }

    const handleAddFuelExpenseClose = () => {
        setAddFuelExpenseOpen(false);
        setEditExpenseDialog(false);
        setSingleExpenseDetails({});
    }

    const handleExpenseConfirm = () => {
        setAddFuelExpenseOpen(false);
        setEditExpenseDialog(false);
        setSingleExpenseDetails({});
        recall();
    }

    const handleEditExpense = (expenseId) => {
        setEditExpenseDialog(true);
        setExpenseIdValue(expenseId);
        dispatchFetchSingleExpense(expenseId,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log("Single Vehicle Component Dweb", "Get single expense details successfull");
                    setAddFuelExpenseOpen(true);
                }
            },
            () => {
                logger.log("Single Vehicle Component Dweb", "Get single expense details failed");
            }
        );
    }

    const handleCustomFilterClose = () => {
        setCustomFilter(false);
    }

    const handleCustomFilterConfirm = (value) => {
        setDateFilterValue("CUSTOM");
        setCustomFilter(false);
        setCustomFilterValue(value);
    }

    return (
        <>
            {onOpen && <RightSideBar
                sideBarName="fuel-book"
                rightSideBarOpen={onOpen}
                sideBarTitle={'Fuel Book'}
                sideBarType="truckBook"
                vehicleNumberValue={vehicleNumberType}
                truckType={fuelBookDetails && fuelBookDetails.vehicleBodyType ? fuelBookDetails.vehicleBodyType : ""}
                handleSubmit={event => submit(event)}
                addExpense={handleAddFuelExpense}
                toggleRightSideBar={onConfirm} >

                <div>
                    <div className={classes.dateRange}>Date Range</div>
                    <DateFilter dateValue={handleDateValue} fromSingleVehicle={true} defaultValue={dateFilterValue} />
                </div>

                {fuelBookDetails.totalCount == 0 &&
                    <>
                        <div className={classes.divEmptyState}>
                            <FuelBookIcon className={classes.fuelBookIcon}></FuelBookIcon>
                            <div className={classes.emptyState}>Add your Fuel expenses to get <div>monthly Truck Profit</div></div>
                        </div>
                    </>
                }

                {fuelBookDetails.totalCount > 0 &&
                    <>
                        <div className={classes.marginV1}>
                            <Card className={classes.cardV2}>
                                <CardContent className={classes.cardContentV1}>
                                    <div>
                                        <div className={classes.titleV1}>Refuel Qty.</div>
                                        <div className={classes.totalRevenue}>{fuelBookDetails && fuelBookDetails.refuelQuantity ? fuelBookDetails.refuelQuantity : ""}</div>
                                    </div>
                                    <div>
                                        <div className={classes.titleV1}>Mileage</div>
                                        <div className={classes.totalRevenue}>{fuelBookDetails && fuelBookDetails.mileage ? fuelBookDetails.mileage : ""}</div>
                                    </div>
                                    <div>
                                        <div className={classes.titleV1}>Total Cost</div>
                                        <div className={classes.totalRevenue}><span>{(fuelBookDetails.totalCost || fuelBookDetails.totalCost == 0) && fuelBookDetails.totalCost != "-" ? numberFormat(fuelBookDetails.totalCost) : fuelBookDetails.totalCost}</span></div>
                                    </div>
                                </CardContent>
                            </Card>
                        </div>

                        <div className={classes.marginV2}>
                            {
                                (fuelBookDetails && fuelBookDetails.fuelItems) &&
                                <>
                                    <div className={classes.mbV1}>

                                        {
                                            fuelBookDetails.fuelItems.map((fuel) => (
                                                <>

                                                    < div className={classes.divMonth}>
                                                        {fuel.month}
                                                    </div>
                                                    {
                                                        fuel.lineItems.map((items) => (

                                                            <>
                                                                < div className={classes.mtV1}>
                                                                    <Card className={classes.cardV1}>
                                                                        <CardContent className={classes.cardContentV2}>
                                                                            <div>
                                                                                <div className={classes.divHeading}>
                                                                                    <div className={classes.fzV1}>
                                                                                        {items.fuelQuantity ?
                                                                                            (<>
                                                                                                <span>{items.fuelQuantity} L *</span>
                                                                                                <span> &#x20B9; {items.ratePerLitre}</span>
                                                                                                <span>{items.expenseType.toLowerCase() == "fuel_refill" ? <CheckCircleIcon className={classes.doneIcon} /> : ""}</span>
                                                                                            </>)
                                                                                            :
                                                                                            (
                                                                                                <>
                                                                                                    <span>{items.expenseType.toLowerCase() == "fuel_card_recharge" ? "Diesel Recharge" : "Fuel Expense"} {items.expenseType.toLowerCase() == "fuel_card_recharge" ? <CheckCircleIcon className={classes.doneIcon} /> : ""} </span>
                                                                                                </>
                                                                                            )
                                                                                        }
                                                                                    </div>

                                                                                    {items && items.expenseType && items.expenseType.toLowerCase() != "fuel_card_recharge"
                                                                                     && items.expenseType.toLowerCase() != "fuel_refill"
                                                                                     &&
                                                                                        <div className={classes.displayFlex}>
                                                                                            <div>
                                                                                                <IconButton className={classes.pV1} onClick={() => handleEditExpense(items.id)}><EditIcon className={classes.editIcon} /></IconButton>
                                                                                            </div>
                                                                                            <div className={classes.mlV1}>
                                                                                                <IconButton className={classes.pV1} onClick={() => handleDeleteExpense(items.id)}><DeleteIcon className={classes.deleteIcon} /></IconButton>
                                                                                            </div>
                                                                                        </div>
                                                                                    }
                                                                                </div>
                                                                                {items.tripId &&
                                                                                    <div className={classes.divFromATrip}>
                                                                                        <div className={classes.fromATrip}>From a trip</div>
                                                                                    </div>
                                                                                }

                                                                                <div className={classes.divData}>
                                                                                    <div className={classes.divV2}>
                                                                                        <span>{getDateStringDDMMM(items.expenseDate)}</span>
                                                                                        {items.kmReading &&
                                                                                            <>
                                                                                                <span className={classes.bullet}>•</span>
                                                                                                <span>{numberFormatComma(items.kmReading)} Kms</span>
                                                                                            </>
                                                                                        }
                                                                                        {items.bunkName &&
                                                                                            <>
                                                                                                <span className={classes.bullet}>•</span>
                                                                                                <span>{items.bunkName}</span>
                                                                                            </>
                                                                                        }
                                                                                    </div>

                                                                                    <div className={classes.divAmount}>
                                                                                        {numberFormat(items.amount)}
                                                                                    </div>

                                                                                </div>
                                                                            </div>
                                                                        </CardContent>
                                                                    </Card>
                                                                </div>
                                                            </>
                                                        ))
                                                    }
                                                </>


                                            ))
                                        }
                                    </div>
                                </>
                            }
                        </div>
                    </>
                }
            </RightSideBar>
            }
            {deleteExpenseDialogOpen && <DeleteExpenseDialog open={deleteExpenseDialogOpen} onClose={handleDeleteClose} onConfirm={handleDeleteExpenseConfirm} expenseParentType={"fuel"} expenseId={expenseIdValue} />}
            {addFuelExpenseOpen && <AddFuelExpenseDialog open={addFuelExpenseOpen} onClose={handleAddFuelExpenseClose} onConfirm={handleExpenseConfirm} fuelExpenseData={singleExpenseDetails} edit={editExpenseDialog} expenseId={expenseIdValue} />}
            {customFilter && <CustomDateFilterDialog open={customFilter} onClose={handleCustomFilterClose} onConfirm={handleCustomFilterConfirm} />}

        </>
    )
}

const mapStateToProps = (state) => ({ vehicle: state.vehicle });
const mapDispatchToProps = (dispatch) => ({
    dispatchGetSingleTruck: (truckId, onSuccess, onFailure) => dispatch(singleTruck(truckId, onSuccess, onFailure)),
    dispatchGetFuelBook: (data, onSuccess, onFailure) => {
        dispatch(fetchFuelBook(data, onSuccess, onFailure))
    },
    dispatchGetPandL: (data, defaultDateFilterValue, onSuccess, onFailure) => dispatch(PandL(data, defaultDateFilterValue, onSuccess, onFailure)),
    dispatchGetTripExpenses: (data, defaultTripBookFilterValue, onSuccess, onFailure) => dispatch(Expenses(data, defaultTripBookFilterValue, onSuccess, onFailure)),
    dispatchFetchSingleExpense: (expenseId, onSuccess, onFailure) => dispatch(FetchExpenseDetails(expenseId, onSuccess, onFailure)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FuelBook);
